import { Link } from 'react-router-dom';
import style from './IntuitButton.module.scss';

// Per Intuit guidelines, the "Sign in with Intuit" (SIWI) button is the correct
// button for OpenID Connect / SSO flows — for both login and sign up.
// The "Connect to QuickBooks" (C2QB) button is only for the accounting OAuth scope.
const IntuitButton = ({ label = 'Sign in with Intuit', onClick }) => {
  return (
    <Link to="/auth/intuit" className={style.intuitButtonLink} onClick={onClick}>
      <span className={style.intuitButtonLabel}>{label}</span>
    </Link>
  );
};

export default IntuitButton;
